module.exports = __webpack_public_path__ + "static/media/salma.c1cdb362.jpg";